<template>
  <div class="revision-list d-flex flex-column align-stretch w-100">
    <TimelineRow
      v-for="(revision, index) in revisions"
      :key="revision.id"
      :show-connector="revisions.length > 1"
      :is-read-only="index === 0"
      :is-first="index === 0"
      :is-last="index === revisions.length - 1"
      @click="emit('revision-click', { revision, index })"
    >
      <RevisionListItem
        :revision="{ ...revision, index }"
        @revision-name-edit="emit('revision-name-edit', $event)"
        :is-editable="revisionIsEditable"
      >
        <template #before-revision-item>
          <slot
            name="before-revision-item"
            :revision="revision"
          />
        </template>
      </RevisionListItem>
    </TimelineRow>
  </div>
</template>

<script setup>
import RevisionListItem from './RevisionListItem.vue';
import TimelineRow from './TimelineRow.vue';

defineProps({
  revisions: {
    type: Array,
    required: true,
    default: () => [],
  },
  revisionIsEditable: {
    type: Boolean,
    required: false,
    default: false,
  },
});

const emit = defineEmits(['revision-click', 'revision-name-edit']);
</script>
